/**
 * @generated SignedSource<<7ef71f833687c70b20debbd8d3c28034>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type MilestoneEditFormRepositoryQuery$data = {
  readonly milestone: {
    readonly description: string | null | undefined;
    readonly dueOn: string | null | undefined;
    readonly id: string;
    readonly title: string;
  } | null | undefined;
  readonly viewerCanPush: boolean;
  readonly " $fragmentSpreads": FragmentRefs<"MilestoneFormRepositoryQueryInternal">;
  readonly " $fragmentType": "MilestoneEditFormRepositoryQuery";
};
export type MilestoneEditFormRepositoryQuery$key = {
  readonly " $data"?: MilestoneEditFormRepositoryQuery$data;
  readonly " $fragmentSpreads": FragmentRefs<"MilestoneEditFormRepositoryQuery">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "number"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "MilestoneEditFormRepositoryQuery",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "viewerCanPush",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "number",
          "variableName": "number"
        }
      ],
      "concreteType": "Milestone",
      "kind": "LinkedField",
      "name": "milestone",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "description",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "dueOn",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MilestoneFormRepositoryQueryInternal"
    }
  ],
  "type": "Repository",
  "abstractKey": null
};

(node as any).hash = "e0a22a2084fb5ab908f1e894de46ef66";

export default node;
